var _path, _path2, _path3, _path4, _g, _circle, _rect, _rect2, _rect3, _g2, _circle2, _rect4, _rect5, _rect6, _g3, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 169,
    viewBox: "0 0 226 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M40 48.3965C40 41.7691 45.3726 36.3965 52 36.3965H174C180.627 36.3965 186 41.7691 186 48.3965V167.396H40V48.3965Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M187 167.396V47.3965C187 41.3214 182.075 36.3965 176 36.3965H51C44.9249 36.3965 40 41.3214 40 47.3965V167.396",
    stroke: "#D9D9D9",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 167.396L226 167.396",
    stroke: "#D9D9D9",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41 55.3965L187 55.3965",
    stroke: "#D9D9D9",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1285_8326)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 70,
    width: 106,
    height: 37,
    rx: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 70,
    width: 106,
    height: 37,
    rx: 7,
    stroke: "#D9D9D9",
    strokeWidth: 4
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 88,
    r: 11,
    fill: "#E2E2E2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 78,
    width: 62,
    height: 9,
    rx: 3,
    fill: "#E2E2E2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 91,
    width: 39,
    height: 8,
    rx: 3,
    fill: "#E2E2E2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 91,
    width: 18,
    height: 8,
    rx: 3,
    fill: "#E2E2E2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1285_8326)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 116,
    width: 106,
    height: 37,
    rx: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 116,
    width: 106,
    height: 37,
    rx: 7,
    stroke: "#D9D9D9",
    strokeWidth: 4
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 134,
    r: 11,
    fill: "#E2E2E2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 124,
    width: 62,
    height: 9,
    rx: 3,
    fill: "#E2E2E2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 137,
    width: 39,
    height: 8,
    rx: 3,
    fill: "#E2E2E2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 137,
    width: 18,
    height: 8,
    rx: 3,
    fill: "#E2E2E2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1285_8326)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 29.7676,
    width: 50.053,
    height: 48.455,
    rx: 12,
    transform: "rotate(-7.79974 147 29.7676)",
    fill: "#F85663"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M185.212 54.3817C184.493 53.4583 183.238 50.7384 182.73 47.0311C182.425 44.8047 181.248 42.7906 179.458 41.432C177.668 40.0733 175.412 39.4813 173.186 39.7863C170.959 40.0913 168.945 41.2682 167.587 43.0582C166.228 44.8481 165.636 47.1045 165.941 49.3309C166.449 53.0392 165.971 55.9954 165.526 57.0783C165.412 57.3537 165.373 57.6542 165.412 57.9496C165.452 58.245 165.568 58.5247 165.75 58.7606C165.932 58.9966 166.173 59.1803 166.449 59.2933C166.725 59.4064 167.026 59.4447 167.321 59.4045L171.603 58.8179C171.927 59.7391 172.558 60.5203 173.391 61.0293C174.225 61.5384 175.208 61.744 176.175 61.6115C177.143 61.479 178.034 61.0165 178.7 60.3022C179.366 59.5878 179.764 58.6656 179.828 57.6913L184.11 57.1047C184.405 57.0639 184.684 56.946 184.919 56.7629C185.154 56.5799 185.337 56.3381 185.449 56.0619C185.56 55.7858 185.597 55.4851 185.556 55.1901C185.514 54.8951 185.396 54.6163 185.212 54.3817ZM175.945 59.9336C175.425 60.0047 174.895 59.9127 174.429 59.6703C173.962 59.4279 173.583 59.0469 173.342 58.5797L178.089 57.9295C177.983 58.4441 177.72 58.9132 177.336 59.2721C176.952 59.631 176.466 59.8621 175.945 59.9336Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M202.946 21.2471L202.946 21.2472C202.474 21.7382 202.465 22.5472 202.985 23.036L202.946 21.2471ZM202.946 21.2471L202.948 21.2443M202.946 21.2471L202.948 21.2443M202.948 21.2443C204.399 19.7593 206.064 18.4735 207.658 17.2605L207.658 17.2605M202.948 21.2443L207.658 17.2605M207.658 17.2605L207.659 17.2595M207.658 17.2605L207.659 17.2595M207.659 17.2595C208.2 16.8502 209.019 16.911 209.437 17.508C209.863 18.0636 209.738 18.8548 209.21 19.262L209.21 19.262M207.659 17.2595L209.21 19.262M209.21 19.262L209.207 19.264M209.21 19.262L209.207 19.264M209.207 19.264C207.656 20.4424 206.094 21.6418 204.773 23.0021M209.207 19.264L204.773 23.0021M204.773 23.0021C204.29 23.502 203.488 23.509 202.985 23.036L204.773 23.0021Z",
    fill: "#D9D9D9",
    stroke: "#D9D9D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M199.112 3.78866L199.113 3.78873C199.772 3.94453 200.233 4.60688 200.051 5.31594C199.535 7.54267 198.858 9.71406 198.175 11.862C198.117 12.0417 198.06 12.2213 198.003 12.4007C197.374 14.3731 196.751 16.3277 196.244 18.3148L196.244 18.3148L196.241 18.3243C196.055 18.9957 195.369 19.4052 194.688 19.2347L194.676 19.2316L194.663 19.2277C194.057 19.0418 193.592 18.3937 193.786 17.6845C194.303 15.6728 194.936 13.6958 195.565 11.7335C195.623 11.5529 195.681 11.3725 195.739 11.1921C196.425 9.04677 197.093 6.91386 197.601 4.73459C197.747 4.04965 198.44 3.63029 199.112 3.78866Z",
    fill: "#D9D9D9",
    stroke: "#D9D9D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M185.164 15.9996C184.782 16.1958 184.338 16.0379 184.127 15.6724L181.954 9.70543C182.31 9.52639 182.782 9.67084 182.966 10.0511L185.489 14.9723C185.7 15.3375 185.545 15.8032 185.164 15.9996ZM181.729 9.25874C182.326 8.95863 183.102 9.19354 183.413 9.82737L185.929 14.7344C186.285 15.3661 186.001 16.1306 185.393 16.4441L185.392 16.4443C184.749 16.7751 184.024 16.4942 183.694 15.9224L183.688 15.9116L183.682 15.9006L181.154 10.9722L181.154 10.9723L181.149 10.9621C180.845 10.3339 181.104 9.57616 181.727 9.25967L181.727 9.25966L181.729 9.25874Z",
    fill: "#D9D9D9",
    stroke: "#D9D9D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1285_8326",
    x: 8,
    y: 68,
    width: 114,
    height: 45,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1285_8326"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1285_8326",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1285_8326",
    x: 49,
    y: 114,
    width: 114,
    height: 45,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1285_8326"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1285_8326",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1285_8326",
    x: 148.516,
    y: 24.4902,
    width: 57.1338,
    height: 55.7676,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1285_8326"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1285_8326",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.4706f5d3.svg";
export { ForwardRef as ReactComponent };